import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { GraphApiResult } from '@/models/graphApiResult';
import { AppConfig } from '@/app-config';
import { ApiResult } from '@/enums';
import { PathUtils } from '@/utils/pathUtils';
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { Bucket } from '@/models/bucket';
import { Tasks } from '@/models/tasks';
import { Task } from '@/models/task';
import { PlannerUtils } from '@/utils/plannerUtils';

@Component({
	components: {
	}
})
export default class UserItem extends Vue {
	@Prop() public id!: string;
	@Prop() public name!: string;
	@Prop() public downloadButtonTitle!: string;
	@Prop() public uploadButtonTitle!: string;
	@Prop() public downloadFolderPath!: string;
	@Prop() public uploadFoloderPath!: string;
	@Prop() public channelId!: string;
	@Prop() public planId!: string;
	@Prop() public bucket!: Bucket;
	@Prop() public status!: string;
	private isVisibleButtons: boolean = false;
	private isVisibleStatus: boolean = false;

	@Emit("user-item-button-click")
	public clickButton(id: string, driveItemsPath: string) { }

	public async created(): Promise<void> {
		if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
			// TODO ルーティング
			return;
		}
		const accessToken: string = Vue.$accessTokenInfo.token;
		const myTask: Task | null = await this.getMyTask(
			accessToken,
			this.planId,
			this.bucket.id,
			this.id,
			AppConfig.USER_TASK_NAME_SUBMIT_REPORT
		);
		if (myTask === null) {
			return;
		}
		if (myTask.percentComplete === 100) {
			this.isVisibleButtons = true;
			this.isVisibleStatus = false;
		} else {
			this.isVisibleButtons = false;
			this.isVisibleStatus = true;
		}
	}

	private async getMyTask(
		accessToken: string,
		planId: string,
		bucketId: string,
		userId: string,
		taskTitle: string
	): Promise<Task | null> {
		const tasksResult: GraphApiResult<Tasks> = await PlannerUtils.GetTasks(accessToken, planId);
		if ((tasksResult.result !== ApiResult.Success) || (tasksResult.value === null)) {
			alert('タスクの取得に失敗しました。');
			return null;
		}
		const tasks: Tasks = tasksResult.value;
		const bucketTasks: Tasks = tasks.getBucketTasks(planId, bucketId);
		const myTasks = bucketTasks.getMyTasks(userId);
		const task = myTasks.getByTitle(taskTitle);
		return task;
	}

	private onDownloadButtonClick(): void {
		const driveItemsPath: string = PathUtils.GetUserSubmitReportPath(
			this.id,
			this.name,
			this.channelId,
			this.bucket.name
		);
		this.clickButton(this.id, driveItemsPath);
	}

	private onUploadButtonClick(): void {
		const driveItemsPath: string = PathUtils.GetUserCheckScorePath(
			this.id,
			this.name,
			this.channelId,
			this.bucket.name
		);
		this.clickButton(this.id, driveItemsPath);
	}
}
